/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import kendo from '@bingads-webui/kendo/kendo.data';
var defaultOptions = {
  schema: {
    model: {
      id: '_uniqueId'
    },
    total: 'total'
  },
  dataItems: null,
  dataCallback: null,
  itemIdField: 'id',
  itemIdCallback: null,
  itemFilterField: 'name',
  itemFilterCallback: null,
  listItemSeed: {},
  pageSize: 20
};
var dlbDataSource = function (options) {
  var self = this;
  self.options = $.extend(true, {}, defaultOptions, options);
  self.schemaDataProperty = self.options.schema.data || 'items';
  self.options.schema.data = function (response) {
    return self._mapItems(response[self.schemaDataProperty]);
  };
  self.externalTransport = _.isFunction(self.options.dataCallback);
  self.useCallbackForFilter = self.externalTransport && !self.options.useCallbackForFetchOnly;
  self.dataSource = self._createDataSource();
};
dlbDataSource.prototype.addIfNotExists = function (item) {
  var self = this;
  var uniqueId = self._getItemId(item);
  if (!uniqueId) return false;
  if (self.dataSource.get(uniqueId)) {
    return false;
  }
  self.dataSource.add(self._createListItem(item));
  return true;
};
dlbDataSource.prototype.removeIfExists = function (item) {
  var self = this;
  var itemData = self._getListItemInfo(item);
  if (!itemData.model) {
    return false;
  }
  self.dataSource.remove(itemData.model);
  return true;
};
dlbDataSource.prototype.getItemData = function (item) {
  return this._getListItemInfo(item).data;
};
dlbDataSource.prototype.getItemId = function (item) {
  return this._getListItemInfo(item).uniqueId;
};
dlbDataSource.prototype.filter = function (filterString) {
  var self = this;
  if (!filterString) {
    self.dataSource.filter([]);
  } else {
    if (self.useCallbackForFilter) {
      if (_.isFunction(self.sourceLoadCancelToken)) {
        self.sourceLoadCancelToken();
      }
      self.dataSource.filter({
        value: filterString
      });
    } else if (_.isFunction(self.options.itemFilterCallback)) {
      self.dataSource.filter({
        field: 'data',
        operator: self.options.itemFilterCallback,
        value: filterString
      });
    } else {
      self.dataSource.filter({
        field: 'data.' + self.options.itemFilterField,
        operator: 'contains',
        value: filterString
      });
    }
  }
};
dlbDataSource.prototype.refresh = function () {
  delete this._data;
  this.dataSource.read();
};
dlbDataSource.prototype.refreshItem = function (item) {
  var self = this, listItem = self._getListItemInfo(item), seededItem = self._createListItem(item);
  if (listItem.model) {
    listItem.model.set('data', seededItem.data);
  }
};
dlbDataSource.prototype.getData = function () {
  return _.map(this.dataSource.data(), function (item) {
    return item.get('data').toJSON();
  });
};
dlbDataSource.prototype.getFilterData = function () {
  var dataSource = this.dataSource;
  var filterResult = kendo.data.Query.process(dataSource.data(), {
    filter: dataSource.filter()
  });
  return _.map(filterResult.data, function (item) {
    return item.get('data').toJSON();
  });
};
dlbDataSource.prototype.setItemProperty = function (item, property, value) {
  var sourceItemModel = this._getListItemInfo(item).model;
  if (sourceItemModel) {
    sourceItemModel.set(property, value);
  }
  ;
};
dlbDataSource.prototype._getListItemInfo = function (item, ignoreSourceData) {
  var self = this;
  var model;
  var uniqueId = self._getItemId(item);
  if (uniqueId && typeof item === 'object') {
    model = self.dataSource.get(uniqueId);
    return {
      uniqueId: uniqueId,
      data: item,
      model: model
    };
  } else {
    model = self.dataSource.get(item);
    return {
      uniqueId: item,
      data: model ? model.get('data').toJSON() : null,
      model: model
    };
  }
};
dlbDataSource.prototype._getItemId = function (item) {
  var self = this;
  return _.isFunction(self.options.itemIdCallback) ? self.options.itemIdCallback(item) : item ? item[self.options.itemIdField] : null;
};
dlbDataSource.prototype._mapItems = function (sourceItems) {
  var self = this;
  return _.map(sourceItems, function (item) {
    return self._createListItem(item);
  });
};
dlbDataSource.prototype._createListItem = function (item) {
  var self = this;
  var id = self._getItemId(item);
  var seed = _.isFunction(self.options.listItemSeed) ? self.options.listItemSeed(item, id) : self.options.listItemSeed;
  return _.extend({}, seed, {
    data: item,
    _uniqueId: id
  });
};
dlbDataSource.prototype._createDataSource = function () {
  var self = this;
  var dataSet = {};
  dataSet[self.schemaDataProperty] = self.options.dataItems;
  return new kendo.data.DataSource({
    data: dataSet,
    schema: self.options.schema,
    serverFiltering: self.useCallbackForFilter,
    serverPaging: self.useCallbackForFilter,
    pageSize: self.options.pageSize,
    transport: self.externalTransport ? {
      read: _.bind(!self.useCallbackForFilter ? self._loadDataWithMemoryCache : self._loadRemoteData, self)
    } : undefined
  });
};
dlbDataSource.prototype._loadDataWithMemoryCache = function (kendoReadOptions) {
  var originalSuccess = kendoReadOptions.success, self = this;
  if (self._data) {
    originalSuccess(self._data);
    return;
  }
  kendoReadOptions.success = function (data) {
    self._data = data;
    originalSuccess(data);
  };
  self._loadRemoteData(kendoReadOptions);
};
dlbDataSource.prototype._loadRemoteData = function (kendoReadOptions) {
  var self = this;
  var request = {
    filterText: kendoReadOptions.data.filter && kendoReadOptions.data.filter.filters[0] ? kendoReadOptions.data.filter.filters[0].value : '',
    skip: kendoReadOptions.data.skip,
    take: kendoReadOptions.data.take
  };
  self.sourceLoadCancelToken = self._getCancellationToken(request, kendoReadOptions.error);
  self.options.dataCallback(request, function (error, data) {
    self.sourceLoadCancelToken = null;
    if (error) {
      kendoReadOptions.error(error);
    } else if (!request.cancelled) {
      kendoReadOptions.success(data);
    }
  });
};
dlbDataSource.prototype._getCancellationToken = function (request, errorCallback) {
  return _.bind(function (req, error) {
    error(new Error('Cancel'));
    req.cancelled = true;
  }, self, request, errorCallback);
};
export default dlbDataSource;

